import Immutable from 'immutable';

// @ts-expect-error ts-migrate(7019) FIXME: Rest parameter 'keys' implicitly has an 'any[]' ty... Remove this comment to see the full error message
export const keyIn = (...keys) => {
  const keySet = Immutable.Set(keys);
  // @ts-expect-error ts-migrate(6133) FIXME: 'v' is declared but its value is never read.
  return (v: any, k: any) => keySet.has(k);
};
